import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import { featureToggles, getNationalityList } from '../redux-store/actions';
import { mdmsProp } from '../redux-store/reducers/mdmsData';
import { togglerType } from '../redux-store/types/mdms';

export const useMdmsFatcaData = (): string => {
  const dispatch = useDispatch();
  const { application } = useSelector((state: RootStateType) => state.application);
  const [fatcaToFetch, setFatcaToFetch] = useState<string>('');

  useEffect(() => {
    (async function () {
      try {
        if (Object.keys(application || {}).length !== 0) {
          const { fatcaMasterDataFeatureToggle } = await dispatch(
            featureToggles() as unknown as togglerType
          );
          const dates: string[] = Object.keys(fatcaMasterDataFeatureToggle).sort(
            (a, b) => new Date(b).getTime() - new Date(a).getTime()
          );

          const givenDate = new Date(application?.createdAt || '');

          // Find the first date less than the given date
          const firstDateLessThanGiven = dates.find(
            (date) => new Date(date).getTime() < givenDate.getTime()
          );
          const fatcaToFetch: string =
            fatcaMasterDataFeatureToggle[firstDateLessThanGiven || ''] || '';
          setFatcaToFetch(fatcaToFetch);
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [dispatch, application]);

  return fatcaToFetch;
};

export const useFeatureToggles = (): mdmsProp => {
  const dispatch = useDispatch();
  const mdmsData = useSelector((state: RootStateType) => state.mdmsDataReducer);

  useEffect(() => {
    (async function () {
      try {
        const shouldFetch = Object.values(mdmsData.toggler.dateFeatureToggles).some(
          (date) => !date
        );
        if (shouldFetch) {
          await dispatch(featureToggles());
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [mdmsData.toggler, dispatch]);

  return mdmsData;
};
